var map = {
	"./animal/gray/1.png": 143,
	"./animal/gray/10.png": 144,
	"./animal/gray/11.png": 145,
	"./animal/gray/12.png": 146,
	"./animal/gray/13.png": 147,
	"./animal/gray/14.png": 148,
	"./animal/gray/15.png": 149,
	"./animal/gray/16.png": 150,
	"./animal/gray/17.png": 151,
	"./animal/gray/18.png": 152,
	"./animal/gray/19.png": 153,
	"./animal/gray/2.png": 154,
	"./animal/gray/20.png": 155,
	"./animal/gray/21.png": 156,
	"./animal/gray/22.png": 157,
	"./animal/gray/23.png": 158,
	"./animal/gray/24.png": 159,
	"./animal/gray/25.png": 160,
	"./animal/gray/26.png": 161,
	"./animal/gray/27.png": 162,
	"./animal/gray/28.png": 163,
	"./animal/gray/29.png": 164,
	"./animal/gray/3.png": 165,
	"./animal/gray/30.png": 166,
	"./animal/gray/31.png": 167,
	"./animal/gray/32.png": 168,
	"./animal/gray/33.png": 169,
	"./animal/gray/34.png": 170,
	"./animal/gray/35.png": 171,
	"./animal/gray/36.png": 172,
	"./animal/gray/4.png": 173,
	"./animal/gray/5.png": 174,
	"./animal/gray/6.png": 175,
	"./animal/gray/7.png": 176,
	"./animal/gray/8.png": 177,
	"./animal/gray/9.png": 178,
	"./animal/green/1.png": 179,
	"./animal/green/10.png": 180,
	"./animal/green/11.png": 181,
	"./animal/green/12.png": 182,
	"./animal/green/13.png": 183,
	"./animal/green/14.png": 184,
	"./animal/green/15.png": 185,
	"./animal/green/16.png": 186,
	"./animal/green/17.png": 187,
	"./animal/green/18.png": 188,
	"./animal/green/19.png": 189,
	"./animal/green/2.png": 190,
	"./animal/green/20.png": 191,
	"./animal/green/21.png": 192,
	"./animal/green/22.png": 193,
	"./animal/green/23.png": 194,
	"./animal/green/24.png": 195,
	"./animal/green/25.png": 196,
	"./animal/green/26.png": 197,
	"./animal/green/27.png": 198,
	"./animal/green/28.png": 199,
	"./animal/green/29.png": 200,
	"./animal/green/3.png": 201,
	"./animal/green/30.png": 202,
	"./animal/green/31.png": 203,
	"./animal/green/32.png": 204,
	"./animal/green/33.png": 205,
	"./animal/green/34.png": 206,
	"./animal/green/35.png": 207,
	"./animal/green/36.png": 208,
	"./animal/green/4.png": 209,
	"./animal/green/5.png": 210,
	"./animal/green/6.png": 211,
	"./animal/green/7.png": 212,
	"./animal/green/8.png": 213,
	"./animal/green/9.png": 214,
	"./animal/orange/1.png": 215,
	"./animal/orange/10.png": 216,
	"./animal/orange/11.png": 217,
	"./animal/orange/12.png": 218,
	"./animal/orange/13.png": 219,
	"./animal/orange/14.png": 220,
	"./animal/orange/15.png": 221,
	"./animal/orange/16.png": 222,
	"./animal/orange/17.png": 223,
	"./animal/orange/18.png": 224,
	"./animal/orange/19.png": 225,
	"./animal/orange/2.png": 226,
	"./animal/orange/20.png": 227,
	"./animal/orange/21.png": 228,
	"./animal/orange/22.png": 229,
	"./animal/orange/23.png": 230,
	"./animal/orange/24.png": 231,
	"./animal/orange/25.png": 232,
	"./animal/orange/26.png": 233,
	"./animal/orange/27.png": 234,
	"./animal/orange/28.png": 235,
	"./animal/orange/29.png": 236,
	"./animal/orange/3.png": 237,
	"./animal/orange/30.png": 238,
	"./animal/orange/31.png": 239,
	"./animal/orange/32.png": 240,
	"./animal/orange/33.png": 241,
	"./animal/orange/34.png": 242,
	"./animal/orange/35.png": 243,
	"./animal/orange/36.png": 244,
	"./animal/orange/4.png": 245,
	"./animal/orange/5.png": 246,
	"./animal/orange/6.png": 247,
	"./animal/orange/7.png": 248,
	"./animal/orange/8.png": 249,
	"./animal/orange/9.png": 250,
	"./animal/red/1.png": 251,
	"./animal/red/10.png": 252,
	"./animal/red/11.png": 253,
	"./animal/red/12.png": 254,
	"./animal/red/13.png": 255,
	"./animal/red/14.png": 256,
	"./animal/red/15.png": 257,
	"./animal/red/16.png": 258,
	"./animal/red/17.png": 259,
	"./animal/red/18.png": 260,
	"./animal/red/19.png": 261,
	"./animal/red/2.png": 262,
	"./animal/red/20.png": 263,
	"./animal/red/21.png": 264,
	"./animal/red/22.png": 265,
	"./animal/red/23.png": 266,
	"./animal/red/24.png": 267,
	"./animal/red/25.png": 268,
	"./animal/red/26.png": 269,
	"./animal/red/27.png": 270,
	"./animal/red/28.png": 271,
	"./animal/red/29.png": 272,
	"./animal/red/3.png": 273,
	"./animal/red/30.png": 274,
	"./animal/red/31.png": 275,
	"./animal/red/32.png": 276,
	"./animal/red/33.png": 277,
	"./animal/red/34.png": 278,
	"./animal/red/35.png": 279,
	"./animal/red/36.png": 280,
	"./animal/red/4.png": 281,
	"./animal/red/5.png": 282,
	"./animal/red/6.png": 283,
	"./animal/red/7.png": 284,
	"./animal/red/8.png": 285,
	"./animal/red/9.png": 286,
	"./bus/gray/1.png": 287,
	"./bus/gray/10.png": 288,
	"./bus/gray/11.png": 289,
	"./bus/gray/12.png": 290,
	"./bus/gray/13.png": 291,
	"./bus/gray/14.png": 292,
	"./bus/gray/15.png": 293,
	"./bus/gray/16.png": 294,
	"./bus/gray/17.png": 295,
	"./bus/gray/18.png": 296,
	"./bus/gray/19.png": 297,
	"./bus/gray/2.png": 298,
	"./bus/gray/20.png": 299,
	"./bus/gray/21.png": 300,
	"./bus/gray/22.png": 301,
	"./bus/gray/23.png": 302,
	"./bus/gray/24.png": 303,
	"./bus/gray/25.png": 304,
	"./bus/gray/26.png": 305,
	"./bus/gray/27.png": 306,
	"./bus/gray/28.png": 307,
	"./bus/gray/29.png": 308,
	"./bus/gray/3.png": 309,
	"./bus/gray/30.png": 310,
	"./bus/gray/31.png": 311,
	"./bus/gray/32.png": 312,
	"./bus/gray/33.png": 313,
	"./bus/gray/34.png": 314,
	"./bus/gray/35.png": 315,
	"./bus/gray/36.png": 316,
	"./bus/gray/4.png": 317,
	"./bus/gray/5.png": 318,
	"./bus/gray/6.png": 319,
	"./bus/gray/7.png": 320,
	"./bus/gray/8.png": 321,
	"./bus/gray/9.png": 322,
	"./bus/green/1.png": 323,
	"./bus/green/10.png": 324,
	"./bus/green/11.png": 325,
	"./bus/green/12.png": 326,
	"./bus/green/13.png": 327,
	"./bus/green/14.png": 328,
	"./bus/green/15.png": 329,
	"./bus/green/16.png": 330,
	"./bus/green/17.png": 331,
	"./bus/green/18.png": 332,
	"./bus/green/19.png": 333,
	"./bus/green/2.png": 334,
	"./bus/green/20.png": 335,
	"./bus/green/21.png": 336,
	"./bus/green/22.png": 337,
	"./bus/green/23.png": 338,
	"./bus/green/24.png": 339,
	"./bus/green/25.png": 340,
	"./bus/green/26.png": 341,
	"./bus/green/27.png": 342,
	"./bus/green/28.png": 343,
	"./bus/green/29.png": 344,
	"./bus/green/3.png": 345,
	"./bus/green/30.png": 346,
	"./bus/green/31.png": 347,
	"./bus/green/32.png": 348,
	"./bus/green/33.png": 349,
	"./bus/green/34.png": 350,
	"./bus/green/35.png": 351,
	"./bus/green/36.png": 352,
	"./bus/green/4.png": 353,
	"./bus/green/5.png": 354,
	"./bus/green/6.png": 355,
	"./bus/green/7.png": 356,
	"./bus/green/8.png": 357,
	"./bus/green/9.png": 358,
	"./bus/orange/1.png": 359,
	"./bus/orange/10.png": 360,
	"./bus/orange/11.png": 361,
	"./bus/orange/12.png": 362,
	"./bus/orange/13.png": 363,
	"./bus/orange/14.png": 364,
	"./bus/orange/15.png": 365,
	"./bus/orange/16.png": 366,
	"./bus/orange/17.png": 367,
	"./bus/orange/18.png": 368,
	"./bus/orange/19.png": 369,
	"./bus/orange/2.png": 370,
	"./bus/orange/20.png": 371,
	"./bus/orange/21.png": 372,
	"./bus/orange/22.png": 373,
	"./bus/orange/23.png": 374,
	"./bus/orange/24.png": 375,
	"./bus/orange/25.png": 376,
	"./bus/orange/26.png": 377,
	"./bus/orange/27.png": 378,
	"./bus/orange/28.png": 379,
	"./bus/orange/29.png": 380,
	"./bus/orange/3.png": 381,
	"./bus/orange/30.png": 382,
	"./bus/orange/31.png": 383,
	"./bus/orange/32.png": 384,
	"./bus/orange/33.png": 385,
	"./bus/orange/34.png": 386,
	"./bus/orange/35.png": 387,
	"./bus/orange/36.png": 388,
	"./bus/orange/4.png": 389,
	"./bus/orange/5.png": 390,
	"./bus/orange/6.png": 391,
	"./bus/orange/7.png": 392,
	"./bus/orange/8.png": 393,
	"./bus/orange/9.png": 394,
	"./bus/red/1.png": 395,
	"./bus/red/10.png": 396,
	"./bus/red/11.png": 397,
	"./bus/red/12.png": 398,
	"./bus/red/13.png": 399,
	"./bus/red/14.png": 400,
	"./bus/red/15.png": 401,
	"./bus/red/16.png": 402,
	"./bus/red/17.png": 403,
	"./bus/red/18.png": 404,
	"./bus/red/19.png": 405,
	"./bus/red/2.png": 406,
	"./bus/red/20.png": 407,
	"./bus/red/21.png": 408,
	"./bus/red/22.png": 409,
	"./bus/red/23.png": 410,
	"./bus/red/24.png": 411,
	"./bus/red/25.png": 412,
	"./bus/red/26.png": 413,
	"./bus/red/27.png": 414,
	"./bus/red/28.png": 415,
	"./bus/red/29.png": 416,
	"./bus/red/3.png": 417,
	"./bus/red/30.png": 418,
	"./bus/red/31.png": 419,
	"./bus/red/32.png": 420,
	"./bus/red/33.png": 421,
	"./bus/red/34.png": 422,
	"./bus/red/35.png": 423,
	"./bus/red/36.png": 424,
	"./bus/red/4.png": 425,
	"./bus/red/5.png": 426,
	"./bus/red/6.png": 427,
	"./bus/red/7.png": 428,
	"./bus/red/8.png": 429,
	"./bus/red/9.png": 430,
	"./car/gray/1.png": 431,
	"./car/gray/10.png": 432,
	"./car/gray/11.png": 433,
	"./car/gray/12.png": 434,
	"./car/gray/13.png": 435,
	"./car/gray/14.png": 436,
	"./car/gray/15.png": 437,
	"./car/gray/16.png": 438,
	"./car/gray/17.png": 439,
	"./car/gray/18.png": 440,
	"./car/gray/19.png": 441,
	"./car/gray/2.png": 442,
	"./car/gray/20.png": 443,
	"./car/gray/21.png": 444,
	"./car/gray/22.png": 445,
	"./car/gray/23.png": 446,
	"./car/gray/24.png": 447,
	"./car/gray/25.png": 448,
	"./car/gray/26.png": 449,
	"./car/gray/27.png": 450,
	"./car/gray/28.png": 451,
	"./car/gray/29.png": 452,
	"./car/gray/3.png": 453,
	"./car/gray/30.png": 454,
	"./car/gray/31.png": 455,
	"./car/gray/32.png": 456,
	"./car/gray/33.png": 457,
	"./car/gray/34.png": 458,
	"./car/gray/35.png": 459,
	"./car/gray/36.png": 460,
	"./car/gray/4.png": 461,
	"./car/gray/5.png": 462,
	"./car/gray/6.png": 463,
	"./car/gray/7.png": 464,
	"./car/gray/8.png": 465,
	"./car/gray/9.png": 466,
	"./car/green/1.png": 97,
	"./car/green/10.png": 467,
	"./car/green/11.png": 468,
	"./car/green/12.png": 469,
	"./car/green/13.png": 470,
	"./car/green/14.png": 471,
	"./car/green/15.png": 472,
	"./car/green/16.png": 473,
	"./car/green/17.png": 474,
	"./car/green/18.png": 475,
	"./car/green/19.png": 476,
	"./car/green/2.png": 477,
	"./car/green/20.png": 478,
	"./car/green/21.png": 479,
	"./car/green/22.png": 480,
	"./car/green/23.png": 481,
	"./car/green/24.png": 482,
	"./car/green/25.png": 483,
	"./car/green/26.png": 484,
	"./car/green/27.png": 485,
	"./car/green/28.png": 486,
	"./car/green/29.png": 487,
	"./car/green/3.png": 488,
	"./car/green/30.png": 489,
	"./car/green/31.png": 490,
	"./car/green/32.png": 491,
	"./car/green/33.png": 492,
	"./car/green/34.png": 493,
	"./car/green/35.png": 494,
	"./car/green/36.png": 495,
	"./car/green/4.png": 496,
	"./car/green/5.png": 497,
	"./car/green/6.png": 498,
	"./car/green/7.png": 499,
	"./car/green/8.png": 500,
	"./car/green/9.png": 501,
	"./car/orange/1.png": 502,
	"./car/orange/10.png": 503,
	"./car/orange/11.png": 504,
	"./car/orange/12.png": 505,
	"./car/orange/13.png": 506,
	"./car/orange/14.png": 507,
	"./car/orange/15.png": 508,
	"./car/orange/16.png": 509,
	"./car/orange/17.png": 510,
	"./car/orange/18.png": 511,
	"./car/orange/19.png": 512,
	"./car/orange/2.png": 513,
	"./car/orange/20.png": 514,
	"./car/orange/21.png": 515,
	"./car/orange/22.png": 516,
	"./car/orange/23.png": 517,
	"./car/orange/24.png": 518,
	"./car/orange/25.png": 519,
	"./car/orange/26.png": 520,
	"./car/orange/27.png": 521,
	"./car/orange/28.png": 522,
	"./car/orange/29.png": 523,
	"./car/orange/3.png": 524,
	"./car/orange/30.png": 525,
	"./car/orange/31.png": 526,
	"./car/orange/32.png": 527,
	"./car/orange/33.png": 528,
	"./car/orange/34.png": 529,
	"./car/orange/35.png": 530,
	"./car/orange/36.png": 531,
	"./car/orange/4.png": 532,
	"./car/orange/5.png": 533,
	"./car/orange/6.png": 534,
	"./car/orange/7.png": 535,
	"./car/orange/8.png": 536,
	"./car/orange/9.png": 537,
	"./car/red/1.png": 538,
	"./car/red/10.png": 539,
	"./car/red/11.png": 540,
	"./car/red/12.png": 541,
	"./car/red/13.png": 542,
	"./car/red/14.png": 543,
	"./car/red/15.png": 544,
	"./car/red/16.png": 545,
	"./car/red/17.png": 546,
	"./car/red/18.png": 547,
	"./car/red/19.png": 548,
	"./car/red/2.png": 549,
	"./car/red/20.png": 550,
	"./car/red/21.png": 551,
	"./car/red/22.png": 552,
	"./car/red/23.png": 553,
	"./car/red/24.png": 554,
	"./car/red/25.png": 555,
	"./car/red/26.png": 556,
	"./car/red/27.png": 557,
	"./car/red/28.png": 558,
	"./car/red/29.png": 559,
	"./car/red/3.png": 560,
	"./car/red/30.png": 561,
	"./car/red/31.png": 562,
	"./car/red/32.png": 563,
	"./car/red/33.png": 564,
	"./car/red/34.png": 565,
	"./car/red/35.png": 566,
	"./car/red/36.png": 567,
	"./car/red/4.png": 568,
	"./car/red/5.png": 569,
	"./car/red/6.png": 570,
	"./car/red/7.png": 571,
	"./car/red/8.png": 572,
	"./car/red/9.png": 573,
	"./motorcycle/gray/1.png": 574,
	"./motorcycle/gray/10.png": 575,
	"./motorcycle/gray/11.png": 576,
	"./motorcycle/gray/12.png": 577,
	"./motorcycle/gray/13.png": 578,
	"./motorcycle/gray/14.png": 579,
	"./motorcycle/gray/15.png": 580,
	"./motorcycle/gray/16.png": 581,
	"./motorcycle/gray/17.png": 582,
	"./motorcycle/gray/18.png": 583,
	"./motorcycle/gray/19.png": 584,
	"./motorcycle/gray/2.png": 585,
	"./motorcycle/gray/20.png": 586,
	"./motorcycle/gray/21.png": 587,
	"./motorcycle/gray/22.png": 588,
	"./motorcycle/gray/23.png": 589,
	"./motorcycle/gray/24.png": 590,
	"./motorcycle/gray/25.png": 591,
	"./motorcycle/gray/26.png": 592,
	"./motorcycle/gray/27.png": 593,
	"./motorcycle/gray/28.png": 594,
	"./motorcycle/gray/29.png": 595,
	"./motorcycle/gray/3.png": 596,
	"./motorcycle/gray/30.png": 597,
	"./motorcycle/gray/31.png": 598,
	"./motorcycle/gray/32.png": 599,
	"./motorcycle/gray/33.png": 600,
	"./motorcycle/gray/34.png": 601,
	"./motorcycle/gray/35.png": 602,
	"./motorcycle/gray/36.png": 603,
	"./motorcycle/gray/4.png": 604,
	"./motorcycle/gray/5.png": 605,
	"./motorcycle/gray/6.png": 606,
	"./motorcycle/gray/7.png": 607,
	"./motorcycle/gray/8.png": 608,
	"./motorcycle/gray/9.png": 609,
	"./motorcycle/green/1.png": 610,
	"./motorcycle/green/10.png": 611,
	"./motorcycle/green/11.png": 612,
	"./motorcycle/green/12.png": 613,
	"./motorcycle/green/13.png": 614,
	"./motorcycle/green/14.png": 615,
	"./motorcycle/green/15.png": 616,
	"./motorcycle/green/16.png": 617,
	"./motorcycle/green/17.png": 618,
	"./motorcycle/green/18.png": 619,
	"./motorcycle/green/19.png": 620,
	"./motorcycle/green/2.png": 621,
	"./motorcycle/green/20.png": 622,
	"./motorcycle/green/21.png": 623,
	"./motorcycle/green/22.png": 624,
	"./motorcycle/green/23.png": 625,
	"./motorcycle/green/24.png": 626,
	"./motorcycle/green/25.png": 627,
	"./motorcycle/green/26.png": 628,
	"./motorcycle/green/27.png": 629,
	"./motorcycle/green/28.png": 630,
	"./motorcycle/green/29.png": 631,
	"./motorcycle/green/3.png": 632,
	"./motorcycle/green/30.png": 633,
	"./motorcycle/green/31.png": 634,
	"./motorcycle/green/32.png": 635,
	"./motorcycle/green/33.png": 636,
	"./motorcycle/green/34.png": 637,
	"./motorcycle/green/35.png": 638,
	"./motorcycle/green/36.png": 639,
	"./motorcycle/green/4.png": 640,
	"./motorcycle/green/5.png": 641,
	"./motorcycle/green/6.png": 642,
	"./motorcycle/green/7.png": 643,
	"./motorcycle/green/8.png": 644,
	"./motorcycle/green/9.png": 645,
	"./motorcycle/orange/1.png": 646,
	"./motorcycle/orange/10.png": 647,
	"./motorcycle/orange/11.png": 648,
	"./motorcycle/orange/12.png": 649,
	"./motorcycle/orange/13.png": 650,
	"./motorcycle/orange/14.png": 651,
	"./motorcycle/orange/15.png": 652,
	"./motorcycle/orange/16.png": 653,
	"./motorcycle/orange/17.png": 654,
	"./motorcycle/orange/18.png": 655,
	"./motorcycle/orange/19.png": 656,
	"./motorcycle/orange/2.png": 657,
	"./motorcycle/orange/20.png": 658,
	"./motorcycle/orange/21.png": 659,
	"./motorcycle/orange/22.png": 660,
	"./motorcycle/orange/23.png": 661,
	"./motorcycle/orange/24.png": 662,
	"./motorcycle/orange/25.png": 663,
	"./motorcycle/orange/26.png": 664,
	"./motorcycle/orange/27.png": 665,
	"./motorcycle/orange/28.png": 666,
	"./motorcycle/orange/29.png": 667,
	"./motorcycle/orange/3.png": 668,
	"./motorcycle/orange/30.png": 669,
	"./motorcycle/orange/31.png": 670,
	"./motorcycle/orange/32.png": 671,
	"./motorcycle/orange/33.png": 672,
	"./motorcycle/orange/34.png": 673,
	"./motorcycle/orange/35.png": 674,
	"./motorcycle/orange/36.png": 675,
	"./motorcycle/orange/4.png": 676,
	"./motorcycle/orange/5.png": 677,
	"./motorcycle/orange/6.png": 678,
	"./motorcycle/orange/7.png": 679,
	"./motorcycle/orange/8.png": 680,
	"./motorcycle/orange/9.png": 681,
	"./motorcycle/red/1.png": 682,
	"./motorcycle/red/10.png": 683,
	"./motorcycle/red/11.png": 684,
	"./motorcycle/red/12.png": 685,
	"./motorcycle/red/13.png": 686,
	"./motorcycle/red/14.png": 687,
	"./motorcycle/red/15.png": 688,
	"./motorcycle/red/16.png": 689,
	"./motorcycle/red/17.png": 690,
	"./motorcycle/red/18.png": 691,
	"./motorcycle/red/19.png": 692,
	"./motorcycle/red/2.png": 693,
	"./motorcycle/red/20.png": 694,
	"./motorcycle/red/21.png": 695,
	"./motorcycle/red/22.png": 696,
	"./motorcycle/red/23.png": 697,
	"./motorcycle/red/24.png": 698,
	"./motorcycle/red/25.png": 699,
	"./motorcycle/red/26.png": 700,
	"./motorcycle/red/27.png": 701,
	"./motorcycle/red/28.png": 702,
	"./motorcycle/red/29.png": 703,
	"./motorcycle/red/3.png": 704,
	"./motorcycle/red/30.png": 705,
	"./motorcycle/red/31.png": 706,
	"./motorcycle/red/32.png": 707,
	"./motorcycle/red/33.png": 708,
	"./motorcycle/red/34.png": 709,
	"./motorcycle/red/35.png": 710,
	"./motorcycle/red/36.png": 711,
	"./motorcycle/red/4.png": 712,
	"./motorcycle/red/5.png": 713,
	"./motorcycle/red/6.png": 714,
	"./motorcycle/red/7.png": 715,
	"./motorcycle/red/8.png": 716,
	"./motorcycle/red/9.png": 717,
	"./object/gray/1.png": 718,
	"./object/gray/10.png": 719,
	"./object/gray/11.png": 720,
	"./object/gray/12.png": 721,
	"./object/gray/13.png": 722,
	"./object/gray/14.png": 723,
	"./object/gray/15.png": 724,
	"./object/gray/16.png": 725,
	"./object/gray/17.png": 726,
	"./object/gray/18.png": 727,
	"./object/gray/19.png": 728,
	"./object/gray/2.png": 729,
	"./object/gray/20.png": 730,
	"./object/gray/21.png": 731,
	"./object/gray/22.png": 732,
	"./object/gray/23.png": 733,
	"./object/gray/24.png": 734,
	"./object/gray/25.png": 735,
	"./object/gray/26.png": 736,
	"./object/gray/27.png": 737,
	"./object/gray/28.png": 738,
	"./object/gray/29.png": 739,
	"./object/gray/3.png": 740,
	"./object/gray/30.png": 741,
	"./object/gray/31.png": 742,
	"./object/gray/32.png": 743,
	"./object/gray/33.png": 744,
	"./object/gray/34.png": 745,
	"./object/gray/35.png": 746,
	"./object/gray/36.png": 747,
	"./object/gray/4.png": 748,
	"./object/gray/5.png": 749,
	"./object/gray/6.png": 750,
	"./object/gray/7.png": 751,
	"./object/gray/8.png": 752,
	"./object/gray/9.png": 753,
	"./object/green/1.png": 754,
	"./object/green/10.png": 755,
	"./object/green/11.png": 756,
	"./object/green/12.png": 757,
	"./object/green/13.png": 758,
	"./object/green/14.png": 759,
	"./object/green/15.png": 760,
	"./object/green/16.png": 761,
	"./object/green/17.png": 762,
	"./object/green/18.png": 763,
	"./object/green/19.png": 764,
	"./object/green/2.png": 765,
	"./object/green/20.png": 766,
	"./object/green/21.png": 767,
	"./object/green/22.png": 768,
	"./object/green/23.png": 769,
	"./object/green/24.png": 770,
	"./object/green/25.png": 771,
	"./object/green/26.png": 772,
	"./object/green/27.png": 773,
	"./object/green/28.png": 774,
	"./object/green/29.png": 775,
	"./object/green/3.png": 776,
	"./object/green/30.png": 777,
	"./object/green/31.png": 778,
	"./object/green/32.png": 779,
	"./object/green/33.png": 780,
	"./object/green/34.png": 781,
	"./object/green/35.png": 782,
	"./object/green/36.png": 783,
	"./object/green/4.png": 784,
	"./object/green/5.png": 785,
	"./object/green/6.png": 786,
	"./object/green/7.png": 787,
	"./object/green/8.png": 788,
	"./object/green/9.png": 789,
	"./object/orange/1.png": 790,
	"./object/orange/10.png": 791,
	"./object/orange/11.png": 792,
	"./object/orange/12.png": 793,
	"./object/orange/13.png": 794,
	"./object/orange/14.png": 795,
	"./object/orange/15.png": 796,
	"./object/orange/16.png": 797,
	"./object/orange/17.png": 798,
	"./object/orange/18.png": 799,
	"./object/orange/19.png": 800,
	"./object/orange/2.png": 801,
	"./object/orange/20.png": 802,
	"./object/orange/21.png": 803,
	"./object/orange/22.png": 804,
	"./object/orange/23.png": 805,
	"./object/orange/24.png": 806,
	"./object/orange/25.png": 807,
	"./object/orange/26.png": 808,
	"./object/orange/27.png": 809,
	"./object/orange/28.png": 810,
	"./object/orange/29.png": 811,
	"./object/orange/3.png": 812,
	"./object/orange/30.png": 813,
	"./object/orange/31.png": 814,
	"./object/orange/32.png": 815,
	"./object/orange/33.png": 816,
	"./object/orange/34.png": 817,
	"./object/orange/35.png": 818,
	"./object/orange/36.png": 819,
	"./object/orange/4.png": 820,
	"./object/orange/5.png": 821,
	"./object/orange/6.png": 822,
	"./object/orange/7.png": 823,
	"./object/orange/8.png": 824,
	"./object/orange/9.png": 825,
	"./object/red/1.png": 826,
	"./object/red/10.png": 827,
	"./object/red/11.png": 828,
	"./object/red/12.png": 829,
	"./object/red/13.png": 830,
	"./object/red/14.png": 831,
	"./object/red/15.png": 832,
	"./object/red/16.png": 833,
	"./object/red/17.png": 834,
	"./object/red/18.png": 835,
	"./object/red/19.png": 836,
	"./object/red/2.png": 837,
	"./object/red/20.png": 838,
	"./object/red/21.png": 839,
	"./object/red/22.png": 840,
	"./object/red/23.png": 841,
	"./object/red/24.png": 842,
	"./object/red/25.png": 843,
	"./object/red/26.png": 844,
	"./object/red/27.png": 845,
	"./object/red/28.png": 846,
	"./object/red/29.png": 847,
	"./object/red/3.png": 848,
	"./object/red/30.png": 849,
	"./object/red/31.png": 850,
	"./object/red/32.png": 851,
	"./object/red/33.png": 852,
	"./object/red/34.png": 853,
	"./object/red/35.png": 854,
	"./object/red/36.png": 855,
	"./object/red/4.png": 856,
	"./object/red/5.png": 857,
	"./object/red/6.png": 858,
	"./object/red/7.png": 859,
	"./object/red/8.png": 860,
	"./object/red/9.png": 861,
	"./personal/gray/1.png": 862,
	"./personal/gray/10.png": 863,
	"./personal/gray/11.png": 864,
	"./personal/gray/12.png": 865,
	"./personal/gray/13.png": 866,
	"./personal/gray/14.png": 867,
	"./personal/gray/15.png": 868,
	"./personal/gray/16.png": 869,
	"./personal/gray/17.png": 870,
	"./personal/gray/18.png": 871,
	"./personal/gray/19.png": 872,
	"./personal/gray/2.png": 873,
	"./personal/gray/20.png": 874,
	"./personal/gray/21.png": 875,
	"./personal/gray/22.png": 876,
	"./personal/gray/23.png": 877,
	"./personal/gray/24.png": 878,
	"./personal/gray/25.png": 879,
	"./personal/gray/26.png": 880,
	"./personal/gray/27.png": 881,
	"./personal/gray/28.png": 882,
	"./personal/gray/29.png": 883,
	"./personal/gray/3.png": 884,
	"./personal/gray/30.png": 885,
	"./personal/gray/31.png": 886,
	"./personal/gray/32.png": 887,
	"./personal/gray/33.png": 888,
	"./personal/gray/34.png": 889,
	"./personal/gray/35.png": 890,
	"./personal/gray/36.png": 891,
	"./personal/gray/4.png": 892,
	"./personal/gray/5.png": 893,
	"./personal/gray/6.png": 894,
	"./personal/gray/7.png": 895,
	"./personal/gray/8.png": 896,
	"./personal/gray/9.png": 897,
	"./personal/green/1.png": 898,
	"./personal/green/10.png": 899,
	"./personal/green/11.png": 900,
	"./personal/green/12.png": 901,
	"./personal/green/13.png": 902,
	"./personal/green/14.png": 903,
	"./personal/green/15.png": 904,
	"./personal/green/16.png": 905,
	"./personal/green/17.png": 906,
	"./personal/green/18.png": 907,
	"./personal/green/19.png": 908,
	"./personal/green/2.png": 909,
	"./personal/green/20.png": 910,
	"./personal/green/21.png": 911,
	"./personal/green/22.png": 912,
	"./personal/green/23.png": 913,
	"./personal/green/24.png": 914,
	"./personal/green/25.png": 915,
	"./personal/green/26.png": 916,
	"./personal/green/27.png": 917,
	"./personal/green/28.png": 918,
	"./personal/green/29.png": 919,
	"./personal/green/3.png": 920,
	"./personal/green/30.png": 921,
	"./personal/green/31.png": 922,
	"./personal/green/32.png": 923,
	"./personal/green/33.png": 924,
	"./personal/green/34.png": 925,
	"./personal/green/35.png": 926,
	"./personal/green/36.png": 927,
	"./personal/green/4.png": 928,
	"./personal/green/5.png": 929,
	"./personal/green/6.png": 930,
	"./personal/green/7.png": 931,
	"./personal/green/8.png": 932,
	"./personal/green/9.png": 933,
	"./personal/orange/1.png": 934,
	"./personal/orange/10.png": 935,
	"./personal/orange/11.png": 936,
	"./personal/orange/12.png": 937,
	"./personal/orange/13.png": 938,
	"./personal/orange/14.png": 939,
	"./personal/orange/15.png": 940,
	"./personal/orange/16.png": 941,
	"./personal/orange/17.png": 942,
	"./personal/orange/18.png": 943,
	"./personal/orange/19.png": 944,
	"./personal/orange/2.png": 945,
	"./personal/orange/20.png": 946,
	"./personal/orange/21.png": 947,
	"./personal/orange/22.png": 948,
	"./personal/orange/23.png": 949,
	"./personal/orange/24.png": 950,
	"./personal/orange/25.png": 951,
	"./personal/orange/26.png": 952,
	"./personal/orange/27.png": 953,
	"./personal/orange/28.png": 954,
	"./personal/orange/29.png": 955,
	"./personal/orange/3.png": 956,
	"./personal/orange/30.png": 957,
	"./personal/orange/31.png": 958,
	"./personal/orange/32.png": 959,
	"./personal/orange/33.png": 960,
	"./personal/orange/34.png": 961,
	"./personal/orange/35.png": 962,
	"./personal/orange/36.png": 963,
	"./personal/orange/4.png": 964,
	"./personal/orange/5.png": 965,
	"./personal/orange/6.png": 966,
	"./personal/orange/7.png": 967,
	"./personal/orange/8.png": 968,
	"./personal/orange/9.png": 969,
	"./personal/red/1.png": 970,
	"./personal/red/10.png": 971,
	"./personal/red/11.png": 972,
	"./personal/red/12.png": 973,
	"./personal/red/13.png": 974,
	"./personal/red/14.png": 975,
	"./personal/red/15.png": 976,
	"./personal/red/16.png": 977,
	"./personal/red/17.png": 978,
	"./personal/red/18.png": 979,
	"./personal/red/19.png": 980,
	"./personal/red/2.png": 981,
	"./personal/red/20.png": 982,
	"./personal/red/21.png": 983,
	"./personal/red/22.png": 984,
	"./personal/red/23.png": 985,
	"./personal/red/24.png": 986,
	"./personal/red/25.png": 987,
	"./personal/red/26.png": 988,
	"./personal/red/27.png": 989,
	"./personal/red/28.png": 990,
	"./personal/red/29.png": 991,
	"./personal/red/3.png": 992,
	"./personal/red/30.png": 993,
	"./personal/red/31.png": 994,
	"./personal/red/32.png": 995,
	"./personal/red/33.png": 996,
	"./personal/red/34.png": 997,
	"./personal/red/35.png": 998,
	"./personal/red/36.png": 999,
	"./personal/red/4.png": 1000,
	"./personal/red/5.png": 1001,
	"./personal/red/6.png": 1002,
	"./personal/red/7.png": 1003,
	"./personal/red/8.png": 1004,
	"./personal/red/9.png": 1005,
	"./truck/gray/1.png": 1006,
	"./truck/gray/10.png": 1007,
	"./truck/gray/11.png": 1008,
	"./truck/gray/12.png": 1009,
	"./truck/gray/13.png": 1010,
	"./truck/gray/14.png": 1011,
	"./truck/gray/15.png": 1012,
	"./truck/gray/16.png": 1013,
	"./truck/gray/17.png": 1014,
	"./truck/gray/18.png": 1015,
	"./truck/gray/19.png": 1016,
	"./truck/gray/2.png": 1017,
	"./truck/gray/20.png": 1018,
	"./truck/gray/21.png": 1019,
	"./truck/gray/22.png": 1020,
	"./truck/gray/23.png": 1021,
	"./truck/gray/24.png": 1022,
	"./truck/gray/25.png": 1023,
	"./truck/gray/26.png": 1024,
	"./truck/gray/27.png": 1025,
	"./truck/gray/28.png": 1026,
	"./truck/gray/29.png": 1027,
	"./truck/gray/3.png": 1028,
	"./truck/gray/30.png": 1029,
	"./truck/gray/31.png": 1030,
	"./truck/gray/32.png": 1031,
	"./truck/gray/33.png": 1032,
	"./truck/gray/34.png": 1033,
	"./truck/gray/35.png": 1034,
	"./truck/gray/36.png": 1035,
	"./truck/gray/4.png": 1036,
	"./truck/gray/5.png": 1037,
	"./truck/gray/6.png": 1038,
	"./truck/gray/7.png": 1039,
	"./truck/gray/8.png": 1040,
	"./truck/gray/9.png": 1041,
	"./truck/green/1.png": 1042,
	"./truck/green/10.png": 1043,
	"./truck/green/11.png": 1044,
	"./truck/green/12.png": 1045,
	"./truck/green/13.png": 1046,
	"./truck/green/14.png": 1047,
	"./truck/green/15.png": 1048,
	"./truck/green/16.png": 1049,
	"./truck/green/17.png": 1050,
	"./truck/green/18.png": 1051,
	"./truck/green/19.png": 1052,
	"./truck/green/2.png": 1053,
	"./truck/green/20.png": 1054,
	"./truck/green/21.png": 1055,
	"./truck/green/22.png": 1056,
	"./truck/green/23.png": 1057,
	"./truck/green/24.png": 1058,
	"./truck/green/25.png": 1059,
	"./truck/green/26.png": 1060,
	"./truck/green/27.png": 1061,
	"./truck/green/28.png": 1062,
	"./truck/green/29.png": 1063,
	"./truck/green/3.png": 1064,
	"./truck/green/30.png": 1065,
	"./truck/green/31.png": 1066,
	"./truck/green/32.png": 1067,
	"./truck/green/33.png": 1068,
	"./truck/green/34.png": 1069,
	"./truck/green/35.png": 1070,
	"./truck/green/36.png": 1071,
	"./truck/green/4.png": 1072,
	"./truck/green/5.png": 1073,
	"./truck/green/6.png": 1074,
	"./truck/green/7.png": 1075,
	"./truck/green/8.png": 1076,
	"./truck/green/9.png": 1077,
	"./truck/orange/1.png": 1078,
	"./truck/orange/10.png": 1079,
	"./truck/orange/11.png": 1080,
	"./truck/orange/12.png": 1081,
	"./truck/orange/13.png": 1082,
	"./truck/orange/14.png": 1083,
	"./truck/orange/15.png": 1084,
	"./truck/orange/16.png": 1085,
	"./truck/orange/17.png": 1086,
	"./truck/orange/18.png": 1087,
	"./truck/orange/19.png": 1088,
	"./truck/orange/2.png": 1089,
	"./truck/orange/20.png": 1090,
	"./truck/orange/21.png": 1091,
	"./truck/orange/22.png": 1092,
	"./truck/orange/23.png": 1093,
	"./truck/orange/24.png": 1094,
	"./truck/orange/25.png": 1095,
	"./truck/orange/26.png": 1096,
	"./truck/orange/27.png": 1097,
	"./truck/orange/28.png": 1098,
	"./truck/orange/29.png": 1099,
	"./truck/orange/3.png": 1100,
	"./truck/orange/30.png": 1101,
	"./truck/orange/31.png": 1102,
	"./truck/orange/32.png": 1103,
	"./truck/orange/33.png": 1104,
	"./truck/orange/34.png": 1105,
	"./truck/orange/35.png": 1106,
	"./truck/orange/36.png": 1107,
	"./truck/orange/4.png": 1108,
	"./truck/orange/5.png": 1109,
	"./truck/orange/6.png": 1110,
	"./truck/orange/7.png": 1111,
	"./truck/orange/8.png": 1112,
	"./truck/orange/9.png": 1113,
	"./truck/red/1.png": 1114,
	"./truck/red/10.png": 1115,
	"./truck/red/11.png": 1116,
	"./truck/red/12.png": 1117,
	"./truck/red/13.png": 1118,
	"./truck/red/14.png": 1119,
	"./truck/red/15.png": 1120,
	"./truck/red/16.png": 1121,
	"./truck/red/17.png": 1122,
	"./truck/red/18.png": 1123,
	"./truck/red/19.png": 1124,
	"./truck/red/2.png": 1125,
	"./truck/red/20.png": 1126,
	"./truck/red/21.png": 1127,
	"./truck/red/22.png": 1128,
	"./truck/red/23.png": 1129,
	"./truck/red/24.png": 1130,
	"./truck/red/25.png": 1131,
	"./truck/red/26.png": 1132,
	"./truck/red/27.png": 1133,
	"./truck/red/28.png": 1134,
	"./truck/red/29.png": 1135,
	"./truck/red/3.png": 1136,
	"./truck/red/30.png": 1137,
	"./truck/red/31.png": 1138,
	"./truck/red/32.png": 1139,
	"./truck/red/33.png": 1140,
	"./truck/red/34.png": 1141,
	"./truck/red/35.png": 1142,
	"./truck/red/36.png": 1143,
	"./truck/red/4.png": 1144,
	"./truck/red/5.png": 1145,
	"./truck/red/6.png": 1146,
	"./truck/red/7.png": 1147,
	"./truck/red/8.png": 1148,
	"./truck/red/9.png": 1149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1280;